// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add_new_company_form-component {\n  border: 1px solid var(--text2);\n  border-radius: 8px;\n  padding: 10px; }\n", ""]);
// Exports
module.exports = exports;
